module.exports = __webpack_public_path__ + "static/img/103753.cda66ec5.png";